(function() {
    'use strict';

    const translations = {
        header: 'Grazie!',
        body: 'Inserisci l\'indirizzo email che usi solitamente per gli acquisti.'
    };

    // Flag per tracciare se gli elementi sono già stati tradotti
    const translated = {
        header: false,
        body: false
    };

    function translate() {
        // Se entrambi sono già tradotti, non fare nulla
        if (translated.header && translated.body) {
            return;
        }

        const header = document.querySelector('[data-testid="survey-email-header"]');
        const body = document.querySelector('[data-testid="survey-email-body"]');
        
        if (header && !translated.header) {
            console.log('Translating header...');
            header.innerHTML = translations.header + '<br>';
            translated.header = true;
        }
        
        if (body && !translated.body) {
            console.log('Translating body...');
            const input = body.querySelector('input');
            const inputHtml = input ? input.outerHTML : '';
            body.innerHTML = translations.body + '<br><div>' + inputHtml + '</div>';
            translated.body = true;
        }

        // Se tutto è tradotto, disconnetti l'observer
        if (translated.header && translated.body) {
            observer.disconnect();
            console.log('Translation complete, observer disconnected');
        }
    }

    // Osserva solo le modifiche necessarie
    const observer = new MutationObserver((mutations) => {
        if (!translated.header || !translated.body) {
            translate();
        }
    });

    // Avvia l'observer
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Prima traduzione
    translate();
})();